import React, {useEffect, useState, useCallback, useMemo} from 'react';
import PropTypes from 'prop-types';
import {Table as AntTable, Row, Col} from 'antd';

import Search from './Search';
import Branch from './Branch';
import CustomDatePicker from './CustomDatePicker';
import State from './State';

import { USER_ROLES } from "../../helpers/constants";

import './table.css';

const Table = ({
   columns,
   getData,
   expandedRowRender,
   branches = [],
   currentBranch,
   userRole,
}) => {
    const [filter, setFilter] = useState({
        branches: [currentBranch.uuId],
        states: ['AGREED'],
        search: [],
        terms: [],
        createdAfter: Math.floor((new Date()).setMonth((new Date()).getMonth() - 2) / 1000),
        createdBefore: Math.floor((new Date()).getTime() / 1000)
    });
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const _columns = useMemo(() => {
        return columns;
    }, [columns]);

    const [loading, setLoading] = useState(true);

    const [options, setOptions] = useState({
        pagination: {current: 1, pageSize: 10},
        sort: {field: 'name', order: 'ascend'},
    });

    useEffect(() => {
        _getData();
    }, [options, filter]);

    const _getData = useCallback(() => {
        setLoading(true);
        getData({...options, ...filter}).then((data) => {
            setData(data.applications.map(app => ({...app, key: app.uuId})));
            setTotal(data.totalCount);
            setLoading(false);
        });
    }, [options, filter]);


    const onTableChange = (pagination, filters, sort) => {
        setOptions({pagination, sort: {field: sort.field, order: sort.order}})
    };

    const handleSearch = ({ target: { value } }) => {
        setOptions({...options, pagination: {current: 1, pageSize: 10}})
        if (value.length > 0 && value.length < 3) {
            return;
        }

        return setFilter({...filter, terms: [value]})
    };

    const handleSearchEnter = (val) => {
        setOptions({...options, pagination: {current: 1, pageSize: 10}})
        return setFilter({...filter, terms: [val]})
    }

    const handleStateChange = (val) => {
        setOptions({...options, pagination: {current: 1, pageSize: 10}})
        return setFilter({...filter, states: [val]})
    };

    const handleBranchChange = (val) => {
        setOptions({...options, pagination: {current: 1, pageSize: 10}})
        return setFilter({...filter, branches: [val]})
    };

    const dateChange = (val) => {
        setOptions({...options, pagination: {current: 1, pageSize: 10}})
        return setFilter({...filter, createdAfter: val[0], createdBefore: val[1]});
    };

    return (
        <div>
            <Row
                type='flex'
                justify={userRole === USER_ROLES.manager ? 'space-between' : 'start'}
                className='p-1 bg-white'
            >
                <Col span={2} className='total-count'>
                    <span>Դիմումներ {total}</span>
                </Col>
                <Col span={5} className={userRole === USER_ROLES.seller ? 'row-gutter' : ''}>
                    <Search
                        onSearch={handleSearchEnter}
                        onChange={handleSearch}
                    />
                </Col>
                {userRole === USER_ROLES.manager && (
                    <Col span={5}>
                        <Branch
                            selectedBranchUuId={filter.branches[0]}
                            branches={[{name: 'Բոլորը', uuId: 'ALL_BRANCHES'}, ...branches]}
                            onChange={handleBranchChange}
                        />
                    </Col>
                )}
                <Col span={5} className={userRole === USER_ROLES.seller ? 'row-gutter' : ''}>
                    <State
                        onChange={handleStateChange}
                    />
                </Col>
                {userRole === USER_ROLES.manager && (
                    <Col span={4}>
                        <CustomDatePicker onChange={dateChange}/>
                    </Col>
                )}
            </Row>
            <div className='px-1 pt-1'>
                <AntTable
                    columns={_columns}
                    dataSource={data}
                    onChange={onTableChange}
                    pagination={{
                        ...options.pagination,
                        total: total,
                        showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}`,
                    }}
                    loading={loading}
                    expandedRowRender={expandedRowRender}
                />
            </div>
        </div>
    )
};

Table.propTypes = {
    columns: PropTypes.array.isRequired,
    getData: PropTypes.func.isRequired,
    expandedRowRender: PropTypes.func,
    remove: PropTypes.func,
    branches: PropTypes.array.isRequired,
};

export default Table;
